import { Route, Routes } from "react-router-dom"
import TpScanLanding from "./LandingPage/tpScanLandingPage"
import ScOnBoarding from "./Onboarding"
import ScFullScan from "./Scan/scFullScan"
import BernFlow from "./Result/bearnFlow"
const BearnFlow = () => {
    return (
        <div className="h-full">
            <Routes>
                <Route path="/" element={<TpScanLanding />} />
                <Route path="sc/onboarding" element={<ScOnBoarding />} />

                {/* <Route path="auto" element={<LandingPage />} /> */}
                <Route path="sc/scan" element={<ScFullScan />} />
                <Route path="report" element={<BernFlow />} />
                {/* <Route path="*" element={<PageNotFound />} />  */}
            </Routes>
        </div>
    )
}

export default BearnFlow